import * as types from "../actions/types";



const initialState = {

};


export default function method_assoc(state = initialState, action) {
  switch (action.type) {
    case types.GET_METHOD_ASSOC:
      return {
        ...state,
        list: action.payload
      };
    case types.GET_METHOD_ASSOC_BY_ID:
      return {
        ...state,
        methodAssoc: action.payload
      };
    case types.GET_METHOD_ASSOC_PEOPLE:
      return {
        ...state,
        listPeople: action.payload
      };
    case types.GET_METHOD_ASSOC_MIDS:
      return {
        ...state,
        listMids: action.payload
      };
    case types.CLEAR_METHOD_ASSOC:
      return {
        ...state,
        methodAssoc: null,
        listMids: null
      };
    // case types.SET_METHOD_ASSOC_LOADING:
    //   return {
    //     ...state,
    //     loading: action.payload
    //   };
    default:
      return state;
  }
}